import { detail } from '@/api/merchant/shop'
const state = () => ({
  retailShop: null,
})
const mutations = {
  SET_RETAILSHOP(state, retailShop) {
    state.retailShop = retailShop
  },
}

const actions = {
  /**
   * 当前登录人所属门店信息
   * @param {*} payload
   * @returns
   */
  async FETCH_RETAILSHOP({ commit, state, rootGetters }, payload) {
    // 如果存在则不再发起请求
    if (!payload.needRefresh && state.retailShop) return { data: state.retailShop }
    // 发起 http 请求
    const { data } = await detail({ id: rootGetters['user/shopId'] })
    // mutation
    commit(`SET_RETAILSHOP`, data)
    return { data }
  },
  setRetailShop({ commit }, retailShop) {
    commit(`SET_RETAILSHOP`, retailShop)
  },
}

export default { state, mutations, actions }
